const AI_BASE_URL = 'https://et-pos.store/connector/api/ai-assistant/generate';

export async function generateAiContent(toolId, bodyData) {
  const token = localStorage.getItem('etpos_token');

  const response = await fetch(`${AI_BASE_URL}/${toolId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(bodyData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Request failed: ${response.status}`);
  }

  return response.json();
}
